<template>
  <div class="base-checkbox" :class="rootClassModifier">
    <div class="base-checkbox__label">
      <label
          v-if="label"
          :class="['label', { 'label--checkbox': inputType === 'checkbox' }]"
      >
        {{ label }}
      </label>

      <Modal
          v-if="infoHeading || infoContent"
          :heading="infoHeading"
          :content="infoContent"
      >
        <template #link="{ clicked }">
          <button class="info-icon" @click="clicked">?</button>
        </template>
      </Modal>
    </div>

    <div class="base-checkbox__checkbox" :class="checkboxClassModifier">
      <input
          :id="id"
          type="checkbox"
          v-bind="$attrs"
          :checked="modelValue"
          :class="{ 'base-checkbox__checkbox--invalid': isInvalid }"
          @change="onChange"
      />
      <label :for="id">{{ checkboxLabel }}</label>      
    </div>
    <div v-if="$slots.additionalContent" class="base-checkbox__additional-content">
      <slot name="additionalContent" />
    </div>
  </div>
</template>

<script setup lang="ts">
import Modal from '@components/Modal/Modal.vue';
import type { CheckboxProps } from './CheckBoxProps'; // Måste importera för vue-kompileringen

defineOptions({
  name: 'BaseCheckbox',
  inheritAttrs: false,
});

withDefaults(defineProps<CheckboxProps>(), {
  label: '',
  checkboxLabel: '',
  inputType: '',
  infoHeading: '',
  infoContent: '',
  modelValue: false,
  rootClassModifier: '',
  checkboxClassModifier: '',
  isInvalid: false,
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>();

const onChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit('update:modelValue', target.checked);
};
</script>
